var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 9.52632V4.78947C4 3.78444 4.42143 2.82058 5.17157 2.10991C5.92172 1.39925 6.93913 1 8 1C9.06087 1 10.0783 1.39925 10.8284 2.10991C11.5786 2.82058 12 3.78444 12 4.78947M1 11.4211C1 10.9185 1.21071 10.4366 1.58579 10.0813C1.96086 9.72594 2.46957 9.52632 3 9.52632H13C13.5304 9.52632 14.0391 9.72594 14.4142 10.0813C14.7893 10.4366 15 10.9185 15 11.4211V17.1053C15 17.6078 14.7893 18.0897 14.4142 18.445C14.0391 18.8004 13.5304 19 13 19H3C2.46957 19 1.96086 18.8004 1.58579 18.445C1.21071 18.0897 1 17.6078 1 17.1053V11.4211ZM7 14.2632C7 14.5144 7.10536 14.7554 7.29289 14.933C7.48043 15.1107 7.73478 15.2105 8 15.2105C8.26522 15.2105 8.51957 15.1107 8.70711 14.933C8.89464 14.7554 9 14.5144 9 14.2632C9 14.0119 8.89464 13.7709 8.70711 13.5933C8.51957 13.4156 8.26522 13.3158 8 13.3158C7.73478 13.3158 7.48043 13.4156 7.29289 13.5933C7.10536 13.7709 7 14.0119 7 14.2632Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockIcon);
export default __webpack_public_path__ + "static/media/unlock-icon.66a11d18646a361509c86f8e82a2c290.svg";
export { ForwardRef as ReactComponent };